import './SuperAdminCreateNewPartnerModal.scss';
import {useState, useContext} from "react";
import {FormInput} from "../../Form/Input/FormInput";
import {i18n} from "../../../Utils/i18n/i18n";
import {Button} from "../../Form/Button/Button";
import {buttonColors} from "../../Pickers/InputTheme";
import {SA_createPartner} from "../../../Services/SA_api";
import {GridReactContext} from "../../../Utils/DataGridWrapper/GridContext";
import LoadingSpinner from "../../LoadingSpinner/LoadingSpinner";
import {Modal} from "../../Smart/Modal/Modal";
import {CopyText} from "../../../Utils/CopyText/CopyText";
import {get} from "lodash";


export const SuperAdminCreateNewPartnerModal = ({createPartnerModalOpen, closeCreatePartnerModal, onCompleted}) => {
    const [partnerName, setPartnerName] = useState()
    const [identifier, setIdentifier] = useState()
    const [contactPhone, setContactPhone] = useState()
    const [contactEmail, setContactEmail] = useState()
    const [contactFirstName, setContactFirstName] = useState()
    const [contactLastName, setContactLastName] = useState()
    const [isLoading, setIsLoading] = useState(false)
    const [partnerData, setPartnerData] = useState(null)

    const gridContext = useContext(GridReactContext)


    const onEditPartnerName = (e) => {
        setPartnerName(e.target.value)
    }

    const onEditIdentifier = (e) => {
        setIdentifier(e.target.value)
    }
    const onEditContactPhone = (e) => {
        setContactPhone(e.target.value)
    }
    const onEditContactEmail = (e) => {
        setContactEmail(e.target.value)
    }

    const onEditContactFirstName = (e) => {
        setContactFirstName(e.target.value)
    }
    const onEditContactLastName = (e) => {
        setContactLastName(e.target.value)
    }
    const onCreatePartner = async () => {
        setIsLoading(true)

        const res = await SA_createPartner({
            partnerName,
            identifier,
            contactPhone,
            contactEmail,
            contactFirstName,
            contactLastName
        })
        setPartnerData(res)
        console.log(res)
        setIsLoading(false)

    }
    const onClose = () => {
        gridContext.triggerTableRefresh()
        onCompleted()
    }

    const buttonDisabled = !partnerName || !identifier
    return <Modal
        open={createPartnerModalOpen}
        onClose={closeCreatePartnerModal}>
        <div className="SuperAdminCreateNewPartner modalWrapper">
            <div className="modalTitle">
                <div>{i18n.translate('superAdmin.createNewPartner.modalTitle')}</div>
            </div>
            <div className="modalContent">
                {!partnerData ? <div className="editContentWrapper">
                        <div className="detailsTitle">
                            <div>{i18n.translate('superAdmin.createNewPartner.detailsTitle')}</div>
                        </div>
                        {isLoading ? <LoadingSpinner/> : ""}
                        <div className="details">
                            <div className="detailsRow">
                                <FormInput
                                    required
                                    id={`partnerName`}
                                    label={i18n.translate('superAdmin.createNewPartner.partnerName')}
                                    className=""
                                    value={partnerName}
                                    onChange={onEditPartnerName}
                                />
                                <FormInput
                                    required
                                    id={`identifier`}
                                    label={i18n.translate('superAdmin.createNewPartner.identifier')}
                                    className=""
                                    value={identifier}
                                    onChange={onEditIdentifier}
                                />
                            </div>


                            <div className="detailsRow">
                                <FormInput
                                    id={`contactPhone`}
                                    label={i18n.translate('superAdmin.createNewPartner.contactPhone')}
                                    className=""
                                    value={contactPhone}
                                    onChange={onEditContactPhone}
                                />
                                <FormInput
                                    id={`contactEmail`}
                                    label={i18n.translate('superAdmin.createNewPartner.contactEmail')}
                                    className=""
                                    value={contactEmail}
                                    onChange={onEditContactEmail}
                                />
                                <FormInput
                                    id={`contactFirstName`}
                                    label={i18n.translate('superAdmin.createNewPartner.contactFirstName')}
                                    className=""
                                    value={contactFirstName}
                                    onChange={onEditContactFirstName}/>
                                <FormInput
                                    id={`contactLastName`}
                                    label={i18n.translate('superAdmin.createNewPartner.contactLastName')}
                                    className=""
                                    value={contactLastName}
                                    onChange={onEditContactLastName}/>
                            </div>
                        </div>

                    </div> :
                    <div className="onAfterPartnerCreated">
                        <div className="clientId">
                            {i18n.translate('superAdmin.createNewPartner.clientId')}
                            <CopyText text={get(partnerData, 'clientId')}/>
                        </div>
                        <div className="clientSecret">
                            {i18n.translate('superAdmin.createNewPartner.clientSecret')}
                            <CopyText text={get(partnerData, 'clientSecret')}/>
                        </div>
                    </div>}
            </div>
            <div className="modalFooter">
                <Button
                    color={buttonColors.YELLOW}
                    onClick={closeCreatePartnerModal}
                    text={i18n.translate('general.close')}
                />
                {!partnerData ? <Button
                        disabled={buttonDisabled}
                        color={buttonColors.GREY}
                        onClick={onCreatePartner}
                        text={i18n.translate('superAdmin.createNewPartner.createPartner')}
                    /> :
                    <Button
                        disabled={buttonDisabled}
                        color={buttonColors.GREY}
                        onClick={onClose}
                        text={i18n.translate('general.close')}
                    />}

            </div>
        </div>
    </Modal>
}